// tableThemeConfig.js
import { darken, lighten } from '@mui/material'; // Correct import for darken and lighten
import { Smoke, Bone } from '@apptronik/react-exoskeleton';

// Common muiTableBodyProps
export const getMuiTableBodyProps = (darkMode) => {
  const baseBackgroundColor = darkMode ? Smoke : Bone; // Dynamically determine base color

  return {
    sx: {
      '& tr > td': {
        backgroundColor: baseBackgroundColor,
      },
      '& tr:hover > td': {
        backgroundColor: darken(baseBackgroundColor, 0.05),
      },
    },
  };
};

// Common theme configuration
export const getTableTheme = (darkMode) => ({
  baseBackgroundColor: darkMode ? Smoke : Bone,
  draggingBorderColor: darkMode ? Smoke : Bone,
});